<template>
	<el-dialog 
		:title="'绑定手机号码'"
		:visible.sync="visible"
		width="600px"
		:before-close="handleClose">
		<el-form :model="form"  :rules="rules" ref="form" label-width="100px" style="padding: 0px 15px 0 4px">
			<el-form-item label="验证码" prop="checkCode" v-if="verificationCodeShow">
				<el-input v-model="form.checkCode"></el-input>
				<img :src="img_src" alt="点击刷新图片" @click="reflash" style="width: 289px;height:37px;margin: 10px 0 0 10px;"/>
				<el-button type="primary" style="float:left;margin-top:10px;" @click="setCheckNumber" v-text="expirationDate==='due'?'请等待' + '(' + timerData + ')':'发送验证码'" :disabled="expirationDate==='due'"></el-button>
			</el-form-item>
			<el-form-item label="短信验证码" prop="checkNumber">
				<el-input v-model="form.checkNumber" />
			</el-form-item>
			<el-form-item label="新手机号" prop="mobile">
				<el-input v-model="form.mobile" />
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" @click="submit">提交</el-button>
			<el-button @click="close">取消</el-button>
		</div>
	</el-dialog>
</template>

<script>
import { UserCenterService } from '../../../service/userCenter.service'
import { LoginService } from '../../../service/login.service';
import cookie from 'vue-cookies'
import Axios from 'axios'

  export default {
    data() {
		var checkPhone = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('手机号不能为空'));
			} else {
				if (/^1[3|4|5|8][0-9]\d{4,8}$/.test(value)) {
					callback();
				} else {
					return callback(new Error('请输入正确的手机号'));
				}
			}
		}
		return {
			img_src: '',
			old_mobile: '',
			verificationCode: '',
			visible: false,
			openType: '',
			timerData: 60,
			verificationCodeShow: true,
			expirationDate: cookie.get('expirationDate'),
			form: {
				account: '',
				tag: 'account',
				smsCode: '',
				mobile:'',
				checkNumber:'',
				checkCode:''
			},
			rules: {
				checkCode:[
					{ required:true,message: '请输入验证码',trigger: 'blur' },
				],
				checkNumber: [
					{ required: true,message: '请输入短信验证码', trigger: 'blur' },
				],
				mobile: [
					{ required: true,validator: checkPhone, trigger: 'blur' },
				]
			},
		}
    },
    watch: {
        timerData(newV) {
            return newV
        }
    },
    methods: {
		async open(data) {
			this.visible = true;
			this.reflash()
			this.timer()
			this.old_mobile = data
		},
		async submit() {
			let params = {
				tag:'mobile',
				mobile:this.form.mobile,
				smsCode:this.form.checkNumber
			}
			if(this.$refs.form.validate()) {
				const data = await UserCenterService.changeEmailOrMobile(params)
				this.$emit('submitSuccess',data.data)
				this.close();
			}
		},
		reflash() {
			var url = 'https://api.goodyiyao.cn/web/other/digitalVerificationCode?model=codeSend'
			let that = this
			Axios.get(url,{ responseType: 'arraybuffer',withCredentials: true}).then(function(res){
			let codeImg =  'data:image/png;base64,' + btoa(
			new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))
			that.img_src = codeImg
			})
		},
		async setCheckNumber() {
			await LoginService.setCheckNumber({account:this.old_mobile,model:'codeSend',code_num:this.form.checkCode,type:'mobile'})
			this.expirationDate = cookie.get('expirationDate')
			cookie.set('expirationDate', 'due', 60);
			cookie.set('changeMobileStart_time',Number(new Date()),60)
			this.timer()
			this.verificationCodeShow = false
		},
		timer() {
			let setTimeout =  cookie.get('changeMobileStart_time')
			let newDate = 60 - (parseInt(Number(new Date())/1000) - parseInt(setTimeout/1000))
			let timer = setInterval(()=>{
				if(newDate > 0 ){newDate -- ;this.timerData = newDate}
				else {clearInterval(timer);this.expirationDate = cookie.get('expirationDate')}
			},1000)
		},
		close() {
			this.form = {}
			this.visible = false
			this.verificationCodeShow = true
		},
		handleClose() {
			this.close()
		},
    },
  }
</script>

<style lang="scss">
	.formItemFill .el-dialog__wrapper{
		z-index: 2500!important;
	}
	.rotationChart{
		.el-dialog__wrapper{
		.upload.formItemFill{
			height: 8vw;
			position: relative;
			.el-upload-list__item{
			margin-top: 0;
			}
			.el-button{
			position: absolute;
			top: 0px;
			left: 120px;
			}
		}
		.bg_color.formItemFill{
			height: 8vw;
			.el-color-picker__trigger{
			width: 100%;
			height: 93px;
			margin-top: -3px;
			.el-color-picker__icon{
				display: none;
			}
			}
		}
		}
	}
	.imgBox{
		text-align: left;
		border: 1px solid #e6e6e6;
		height: 6.2vw;
		img{
		height: 6.2vw;
		}
  }
</style>